import { useState } from "react";
import instance from "../../../Interceptor/api_instance";
import { SpinnerOverlay } from "../../../Components/LoadingAnimations/SpinnerOverlay";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";

const DeleteMaintenanceReport = ({ id, close }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const response = await instance.delete(
        `safety/delete-maintenance-report/${id}`
      );
      if (response.status === 200) {
        setResponseModal({
          status: t("forms.type.success"),
          message: t("forms.responses.success"),
        });
      }
    } catch (error) {
      setResponseModal({
        status: "Error",
        message: error,
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="page-mask page-mask-animation">
      {isLoading && <SpinnerOverlay />}
      {responseModal && (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={() => {
            if (responseModal.status === t("forms.type.success")) {
              close();
              navigate("/maintenance-reports");
            } else {
              setResponseModal(null);
            }
          }}
        />
      )}
      <div className="response-modal">
        <h2 className="global-h2">
          {t("forms.type.maintenance-report.delete")}
        </h2>
        <h4 className="global-h4 gray">
          {t("warnings.delete-maintenance-report")}
        </h4>
        <h4 className="global-h4 gray">{t("forms.type.continue")}</h4>
        <div className="flex-1">
          <button className="change-pwd-btn" onClick={() => handleDelete()}>
            {t("buttons.delete")}
          </button>
          <button className="all-btn cancel-btn" onClick={close}>
            {t("buttons.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMaintenanceReport;
